import { animated, useSpring, useTrail } from '@react-spring/web';
import { useInView } from 'react-intersection-observer';

export const AnimatedText = ({ children, className }: { children: string; className?: string }) => {
  const { ref, inView } = useInView({ threshold: 0.5, triggerOnce: false });

  const letters = children.split('');

  const trail = useTrail(letters.length, {
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: { tension: 200, friction: 25 },
    delay: inView ? 0 : undefined,
  });

  return (
    <span ref={ref}>
      {trail.map((style, index) => (
        <animated.span key={index} style={style} className={className}>
          {letters[index] === ' ' ? '\u00A0' : letters[index]}
        </animated.span>
      ))}
    </span>
  );
};
